"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_CHECKOUT = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var react_apollo_1 = require("react-apollo");
var mutation_create_checkout_1 = require("./mutation_create_checkout");
exports.UPDATE_CHECKOUT = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UpdateCheckout($token: String!, $email: String, $lineItems: [LineItemInput], $shippingAddress: ShippingAddressInput, $billingAddress: BillingAddressInput, $shippingLineHandle: String, $discountCode: String, $acceptsMarketing: Boolean) {\n    updateCheckout(token: $token, email: $email, lineItems: $lineItems, shippingAddress: $shippingAddress, billingAddress: $billingAddress, shippingLineHandle: $shippingLineHandle, discountCode: $discountCode, acceptsMarketing: $acceptsMarketing) ", "\n  }\n"], ["\n  mutation UpdateCheckout($token: String!, $email: String, $lineItems: [LineItemInput], $shippingAddress: ShippingAddressInput, $billingAddress: BillingAddressInput, $shippingLineHandle: String, $discountCode: String, $acceptsMarketing: Boolean) {\n    updateCheckout(token: $token, email: $email, lineItems: $lineItems, shippingAddress: $shippingAddress, billingAddress: $billingAddress, shippingLineHandle: $shippingLineHandle, discountCode: $discountCode, acceptsMarketing: $acceptsMarketing) ", "\n  }\n"])), mutation_create_checkout_1.CHECKOUT_RETURN_QUERY);
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return default_1;
}(react_apollo_1.Mutation));
exports.default = default_1;
var templateObject_1;
